import { UserVoucherDTO } from "../models/voucher";
import { get, baseUrl } from "./api_service";
import { getTokens } from "./auth_service";

export async function getUsersVouchers(): Promise<UserVoucherDTO[] | undefined> {
  const response = await get(`${baseUrl}/user/vouchers`, getTokens().token);
  return response;
}

